export const SHAREPOINT = 'sharepoint'

export const sharePointPath = (): string => `/${SHAREPOINT}`
